import React from 'react';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SimpleNotesInput from '../../UI/SimpleNotesInput';

const IncidentTriggerPanel = ({
  behaviorPalette,
  surfaceColor,
  inkColor,
  notes,
  setNotes,
  selectedTriggers,
  toggleTrigger,
  triggerGroups,
  title = 'What might have triggered this?',
  helperText = 'Pick any that apply. You can also add a note.',
  notesLabel = 'Possible trigger',
  notesPlaceholder = 'Anything else to add?',
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      borderRadius: '16px',
      bgcolor: alpha(behaviorPalette.bg, 0.28),
      border: `1px solid ${behaviorPalette.bg}`,
    }}
  >
    <Typography sx={{ fontSize: 14, fontWeight: 700, color: behaviorPalette.ink, mb: 0.5 }}>
      {title}
    </Typography>
    <Typography sx={{ fontSize: 12.5, color: alpha(behaviorPalette.ink, 0.75), mb: 1.5 }}>
      {helperText}
    </Typography>

    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {triggerGroups.map((group) => {
        const selected = selectedTriggers.includes(group.key);
        const TriggerIcon = group.icon;
        return (
          <ButtonBase
            key={group.key}
            onClick={() => toggleTrigger(group.key)}
            sx={{
              px: 1.35,
              py: 0.85,
              borderRadius: 999,
              border: `1.5px solid ${selected ? behaviorPalette.ink : alpha(behaviorPalette.bg, 0.95)}`,
              bgcolor: selected ? behaviorPalette.ink : surfaceColor,
              color: selected ? surfaceColor : behaviorPalette.ink,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.6,
              fontWeight: 650,
              fontSize: 12.5,
              lineHeight: 1,
              transition: 'all 180ms ease',
            }}
          >
            {TriggerIcon ? <TriggerIcon sx={{ fontSize: 13 }} /> : null}
            <Box component="span">{group.label}</Box>
          </ButtonBase>
        );
      })}
    </Box>

    <SimpleNotesInput
      label={notesLabel}
      hintText="Tip: use your phone mic to dictate notes."
      value={notes}
      onDataChange={(data) => setNotes(data?.text || '')}
      placeholder={notesPlaceholder}
      minRows={2}
      textFieldSx={{
        mt: 1.5,
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          bgcolor: surfaceColor,
          minHeight: 80,
          alignItems: 'flex-start',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: alpha(behaviorPalette.bg, 0.92),
          borderWidth: '1px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: behaviorPalette.bg,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: behaviorPalette.ink,
        },
        '& .MuiInputBase-input': {
          fontSize: '0.906rem',
          lineHeight: 1.45,
          color: inkColor,
        },
      }}
    />
  </Paper>
);

export default IncidentTriggerPanel;
